import { type ComponentProps, type ForwardRefExoticComponent, type RefAttributes, useEffect } from 'react'

import { Label } from '@/components/ui/label.tsx'

import { EditableComponent } from '@/components/EditableComponent.tsx'
import { Comment } from '@/components/form/Comment.tsx'
import { DEFAULT_COMMENT } from '@/constants/DEFAULT_VALUES'
import { TEMPORARY_ID_PREFIX } from '@/constants/PREFIX.ts'
import { useAttachment } from '@/contexts/AttachmentContext.tsx'
import { useUserContext } from '@/contexts/UserContext.tsx'

type EditableVersionProps = {
  storyId: string
  value?: StoryComment[]
  placeholder: string
}

export const EditableComments = ({ storyId, value = [], placeholder }: EditableVersionProps) => {
  // biome-ignore lint/style/noNonNullAssertion: This is guaranteed to be non-null
  const user = useUserContext().user!
  const { initializeAttachments } = useAttachment()

  useEffect(() => {
    initializeAttachments(value)
  }, [value, initializeAttachments])

  return (
    <>
      <Label variant="title">Activity</Label>
      <div className="flex flex-col gap-5">
        {[...(value ?? [])]
          .sort((a, b) => a.createdAt - b.createdAt)
          .map((comment) => (
            <Comment
              key={comment.id}
              modes={user.id.toString() === comment.user.id.toString() ? ['view', 'edit'] : ['view']}
              comment={comment}
              placeholder={placeholder}
            />
          ))}
      </div>
      <Comment
        modes={['edit']}
        comment={DEFAULT_COMMENT(storyId, user, `${TEMPORARY_ID_PREFIX}${storyId}`)}
        placeholder={placeholder}
      />
    </>
  )
}

export const TypedEditableComments = EditableComponent as unknown as ForwardRefExoticComponent<
  EditableProps<StoryComment[], undefined, ComponentProps<typeof EditableComments>> & RefAttributes<EditableCommands>
>
